// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__bv8Dl","infoBtn":"quickbooks_infoBtn__9Tvt9","formBox":"quickbooks_formBox__15ezC","formFooter":"quickbooks_formFooter__3CMt7"};